import React from 'react';
export function useTouchEvents(_ref) {
  var getEnvironmentProps = _ref.getEnvironmentProps,
    panelElement = _ref.panelElement,
    formElement = _ref.formElement,
    inputElement = _ref.inputElement;
  React.useEffect(function () {
    if (!(panelElement && formElement && inputElement)) {
      return undefined;
    }
    var _getEnvironmentProps = getEnvironmentProps({
        panelElement: panelElement,
        formElement: formElement,
        inputElement: inputElement
      }),
      onTouchStart = _getEnvironmentProps.onTouchStart,
      onTouchMove = _getEnvironmentProps.onTouchMove;
    window.addEventListener('touchstart', onTouchStart);
    window.addEventListener('touchmove', onTouchMove);
    return function () {
      window.removeEventListener('touchstart', onTouchStart);
      window.removeEventListener('touchmove', onTouchMove);
    };
  }, [getEnvironmentProps, panelElement, formElement, inputElement]);
}